/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import dayjs from 'dayjs';

export const getFilterDateRanges = () => {
  const now = dayjs();
  const currentYear = now.year();

  return [
    {
      label: 'Last 30 days',
      from: now.subtract(30, 'day').startOf('day').toDate(),
      to: now.endOf('day').toDate(),
    },
    {
      label: 'Last 90 days',
      from: now.subtract(90, 'day').startOf('day').toDate(),
      to: now.endOf('day').toDate(),
    },
    {
      label: `This year (${currentYear})`,
      from: now.startOf('year').toDate(),
      to: now.endOf('day').toDate(),
    },
    {
      label: `Last year (${currentYear - 1})`,
      from: now.subtract(1, 'year').startOf('year').toDate(),
      to: now.subtract(1, 'year').endOf('year').toDate(),
    },
  ];
};
